import { Text, Anchor, Heading } from "grommet";

export function LoginText() {
  return <Text>Predict life-threatening ventricular arrhythmia risk in DCM patients using an explainable neural network</Text>;
}

export function Citation() {
  return (
    <Text>
      The paper about this model can be found{" "}
      <Anchor href="https://academic.oup.com/europace/advance-article/doi/10.1093/europace/euac054/6618973?login=false" label="here" />.
    </Text>
  );
}

export function SidebarHeading() {
  return (
    <Heading level={1} textAlign="start" margin="none">
      Predict life-threatening ventricular arrhythmia risk in DCM patients using an explainable neural network
    </Heading>
  );
}

export function MajorDescription() {
  return (
    <Text>
      This tool provides an interactive way to visualize an inherently explainable deep neural network (DNN), that learned the underlying
      anatomical and (patho)physiological explanatory factors of variation of the ECG: <b>the FactorECG</b>. Afterwards, it was trained to
      predict life treathening ventricular arrhythmia (LTVA) in DCM patients.
    </Text>
  );
}

export function MinorDescription() {
  return (
    <Text>
      The ECG can be compressed into 21 significant factors, that allow for reconstruction of the full median beat ECG. To encode the ECG
      into these factors, an unsupervised beta variational auto-encoder (VAE) was trained to reconstruct 1,144,331 median beat ECGs from
      these 21 factors. The current trained model is able to encode any median beat ECG into these 21 factors, and is able to interactively
      generate new ECGs by adjusting the factors.
      <br />
      <br />
      The obtained ECG factors were used as input to a Cox regression model to predict life treathening ventricular arrhythmia (sudden
      cardiac arrest, spontaneous sustained ventricular tachycardia, or implantable cardioverter-defibrillator treated ventricular
      arrhythmia).
    </Text>
  );
}

export function Instructions() {
  return (
    <Text>
      The goal of this tool is to make the 21 significant ECG factors interpretable for any clinician. The factors can be varied
      interactively using the sliders at the top of the window, while the ECG is generated real-time and predictions of LTVA are produced.
      Moreover, several example ECGs are included on the right to investigate the state of the ECG factors for these examples.
    </Text>
  );
}
